if (window.ProductSliderManager) {
} else {

  window.ProductSliderManager = {
    instances: new Map(),
    initCounter: 0,
    processingTimeout: null,
    observerInstances: new Map(),
    videoObserver: null,
    activeVideos: new Set(),

    // 動画管理システムの初期化
    initializeVideoSystem: function() {
      // Intersection Observer for video autoplay
      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          const container = video.closest('[data-video-container]');
          
          if (entry.isIntersecting) {
            // 表示領域に入った時
            this.playVideoSafely(video, container);
          } else {
            // 表示領域から出た時
            this.pauseVideo(video, container);
          }
        });
      }, {
        threshold: 0.5, // 50%以上表示された時に発火
        rootMargin: '50px' // iOS対応で余裕を持たせる
      });

      // 既存の動画要素を監視対象に追加
      this.observeAllVideos();
    },

    // 全ての動画要素を監視対象に追加
    observeAllVideos: function() {
      const videos = document.querySelectorAll('[data-video-element]');
      videos.forEach(video => {
        this.videoObserver.observe(video);
      });
    },

    // iPhone対応
    playVideoSafely: function(video, container) {
      if (!video || video.dataset.playing === 'true') return;

      const playBtn = container ? container.querySelector('[data-video-play-btn]') : null;
      
      // 自動再生を試行
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // 自動再生成功
            video.dataset.playing = 'true';
            this.activeVideos.add(video);
            if (playBtn) playBtn.style.display = 'none';
          })
          .catch((error) => {
            // 自動再生失敗（iPhone Low Power Mode等）
            video.dataset.playing = 'false';
            if (playBtn) {
              playBtn.style.display = 'flex';
              // 手動再生ボタンのイベントリスナー
              if (!playBtn.dataset.listenerAdded) {
                playBtn.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.manualPlayVideo(video, container);
                });
                playBtn.dataset.listenerAdded = 'true';
              }
            }
          });
      }
    },

    // 手動動画再生
    manualPlayVideo: function(video, container) {
      const playBtn = container ? container.querySelector('[data-video-play-btn]') : null;
      
      video.play()
        .then(() => {
          video.dataset.playing = 'true';
          this.activeVideos.add(video);
          if (playBtn) playBtn.style.display = 'none';
        })
        .catch((error) => {
        });
    },

    // 動画の一時停止
    pauseVideo: function(video, container) {
      if (!video || video.dataset.playing !== 'true') return;

      video.pause();
      video.dataset.playing = 'false';
      this.activeVideos.delete(video);
      
      const playBtn = container ? container.querySelector('[data-video-play-btn]') : null;
      if (playBtn) playBtn.style.display = 'none'; // 一時停止時はボタンを隠す
    },

    // 新しく追加されたスライダーのみを初期化
    initializeNewSliders: function(nodes) {
      if (!nodes || nodes.length === 0) return;

      // Splideライブラリの確認
      if (typeof Splide === 'undefined') {
        setTimeout(() => this.initializeNewSliders(nodes), 500);
        return;
      }

      let newSliders = [];
      let newVideos = [];

      // 追加されたノードからスライダーと動画を検索
      nodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // ノード自体がスライダーの場合
          if (node.classList && node.classList.contains('c-product-item-slider')) {
            newSliders.push(node);
          }
          // ノード内にスライダーがある場合
          const slidersInNode = node.querySelectorAll ? node.querySelectorAll('.c-product-item-slider') : [];
          newSliders = newSliders.concat(Array.from(slidersInNode));

          // 新しい動画要素を検索
          if (node.querySelector && node.querySelector('[data-video-element]')) {
            const videosInNode = node.querySelectorAll('[data-video-element]');
            newVideos = newVideos.concat(Array.from(videosInNode));
          }
          if (node.dataset && node.dataset.videoElement) {
            newVideos.push(node);
          }
        }
      });

      // 新しいスライダーを初期化
      newSliders.forEach(slider => this.initializeSingleSlider(slider));

      // 新しい動画を監視対象に追加
      if (this.videoObserver && newVideos.length > 0) {
        newVideos.forEach(video => {
          this.videoObserver.observe(video);
        });
      }
    },

    // 単一スライダーの初期化
    initializeSingleSlider: function(slider) {
      if (!slider || !slider.dataset) return;

      const sliderId = slider.dataset.sliderId;
      const slideCount = slider.querySelectorAll('.splide__slide').length;

      // スライドが1枚以下の場合はスキップ
      if (slideCount <= 1) return;

      // 既に初期化済みの場合はスキップ
      if (this.instances.has(sliderId)) return;

      try {
        // 既存のクラスをクリア
        slider.classList.remove('is-initialized', 'splide--slide', 'splide--ltr', 'splide--draggable', 'is-active');

        const splide = new Splide(slider, {
          type: 'slide',
          perPage: 1,
          pagination: false,
          arrows: false,
          autoWidth: false,
          fixedWidth: false,
          width: '100%',
          speed: 400,
          rewind: false,
          waitForTransition: false
        });

        // プログレスバーの処理
        const progressBar = slider.querySelector('.c-product-item-slider__progress-bar');
        if (progressBar) {
          splide.on('mounted move', function() {
            try {
              const end = splide.Components.Controller.getEnd() + 1;
              const rate = Math.min((splide.index + 1) / end, 1);
              progressBar.style.width = (100 * rate) + '%';
            } catch (error) {
            }
          });
        }

        // スライド移動時の動画制御
        splide.on('move', (newIndex, oldIndex) => {
          this.handleSlideVideoControl(slider, newIndex, oldIndex);
        });

        // インタラクションに応じてスライド単位で画像先読み（イベントリスナー設定）
        this.setupInteractivePreloading(slider, splide);

        splide.mount();

        // インスタンスを保存
        this.instances.set(sliderId, splide);

        // 初期スライドの動画を処理
        setTimeout(() => {
          this.handleSlideVideoControl(slider, 0, -1);
        }, 100);

      } catch (error) {
      }
    },

    // スライド移動時の動画制御
    handleSlideVideoControl: function(slider, newIndex, oldIndex) {
      const slides = slider.querySelectorAll('.splide__slide');
      
      // 前のスライドの動画を停止
      if (oldIndex >= 0 && oldIndex < slides.length) {
        const oldSlide = slides[oldIndex];
        const oldVideo = oldSlide.querySelector('[data-video-element]');
        if (oldVideo) {
          const oldContainer = oldSlide.querySelector('[data-video-container]');
          this.pauseVideo(oldVideo, oldContainer);
        }
      }

      // 新しいスライドの動画を再生（表示領域内の場合）
      if (newIndex >= 0 && newIndex < slides.length) {
        const newSlide = slides[newIndex];
        const newVideo = newSlide.querySelector('[data-video-element]');
        if (newVideo) {
          const newContainer = newSlide.querySelector('[data-video-container]');
          // スライダーが表示領域内にあるかチェック
          const sliderRect = slider.getBoundingClientRect();
          const isSliderVisible = sliderRect.top < window.innerHeight && sliderRect.bottom > 0;
          
          if (isSliderVisible) {
            setTimeout(() => {
              this.playVideoSafely(newVideo, newContainer);
            }, 200); // スライドアニメーション完了後
          }
        }
      }
    },

    // インタラクション時先読みの設定
    setupInteractivePreloading: function(slider, splideInstance) {
      let preloadTimeout = null;
      let hasPreloaded = false;

      // ドラッグ開始時の先読み
      splideInstance.on('drag', () => {
        if (!hasPreloaded) {
          this.preloadAdjacentImages(slider, splideInstance.index);
          hasPreloaded = true;
          
          // 3秒後にフラグをリセット（再度のインタラクションに備える）
          clearTimeout(preloadTimeout);
          preloadTimeout = setTimeout(() => {
            hasPreloaded = false;
          }, 3000);
        }
      });

      // タッチ/マウス開始時の先読み（バックアップ）
      const startPreload = () => {
        if (!hasPreloaded) {
          clearTimeout(preloadTimeout);
          preloadTimeout = setTimeout(() => {
            this.preloadAdjacentImages(slider, splideInstance.index);
            hasPreloaded = true;
            
            // 3秒後にフラグをリセット
            setTimeout(() => {
              hasPreloaded = false;
            }, 3000);
          }, 100); // 100ms後に先読み開始
        }
      };

      // PC・SP両方に対応
      slider.addEventListener('touchstart', startPreload, { passive: true });
      slider.addEventListener('mousedown', startPreload);

      // スライド完了時に次の画像も先読み
      splideInstance.on('moved', (newIndex) => {
        setTimeout(() => {
          this.preloadAdjacentImages(slider, newIndex);
        }, 200);
      });
    },

    // 隣接画像の先読み処理
    preloadAdjacentImages: function(slider, currentIndex) {
      try {
        const slides = slider.querySelectorAll('.splide__slide');
        const totalSlides = slides.length;

        // 前後1枚ずつを先読み
        const indicesToPreload = [
          currentIndex - 1, // 前
          currentIndex + 1, // 次
          currentIndex + 2  // 次の次（余裕があれば）
        ];

        indicesToPreload.forEach(index => {
          // 範囲チェック
          if (index >= 0 && index < totalSlides) {
            const slide = slides[index];
            const img = slide.querySelector('img');
            
            // 動画の場合はポスター画像を先読み
            const video = slide.querySelector('[data-video-element]');
            if (video && video.poster && !this.isImageLoaded(video)) {
              this.preloadImage(video, true);
            }
            
            if (img && !this.isImageLoaded(img)) {
              this.preloadImage(img);
            }
          }
        });

      } catch (error) {
      }
    },

    // 画像の先読み実行
    preloadImage: function(element, isPoster = false) {
      try {
        // 既に読み込み中または完了している場合はスキップ
        if (element.dataset.preloading === 'true' || this.isImageLoaded(element)) {
          return;
        }

        // 先読み中フラグ
        element.dataset.preloading = 'true';

        let srcToLoad;
        
        if (isPoster && element.poster) {
          // 動画のポスター画像
          srcToLoad = element.poster;
        } else {
          // 通常の画像
          if (element.tagName === 'IMG') {
            element.loading = 'eager';
            if ('fetchPriority' in element) {
              element.fetchPriority = 'high';
            }
            srcToLoad = element.src || element.dataset.src;
          }
        }

        if (srcToLoad) {
          // 新しいImageオブジェクトで先読み
          const preloadImg = new Image();
          preloadImg.onload = preloadImg.onerror = () => {
            element.dataset.preloading = 'false';
          };
          preloadImg.src = srcToLoad;
        }

      } catch (error) {
        element.dataset.preloading = 'false';
      }
    },

    // 画像が読み込み済みかチェック
    isImageLoaded: function(element) {
      if (element.tagName === 'IMG') {
        return element.complete && element.naturalHeight !== 0;
      } else if (element.tagName === 'VIDEO' && element.poster) {
        // 動画のポスター画像の場合は readyState をチェック
        return element.readyState >= 1;
      }
      return false;
    },

    // 全スライダーの初期化（初回読み込み用）
    initializeAllSliders: function() {
      const allSliders = document.querySelectorAll('.c-product-item-slider');
      
      if (allSliders.length === 0) return;

      // Splideライブラリの確認
      if (typeof Splide === 'undefined') {
        setTimeout(() => this.initializeAllSliders(), 1000);
        return;
      }

      allSliders.forEach(slider => this.initializeSingleSlider(slider));
    },

    // Ajax更新時の処理（商品一覧ページ専用）
    handleCollectionAjaxUpdate: function() {
      // 処理中の場合は前回の処理をキャンセル
      if (this.processingTimeout) {
        clearTimeout(this.processingTimeout);
      }

      this.processingTimeout = setTimeout(() => {
        // 強制的に全インスタンスをクリア
        this.instances.forEach((splide, sliderId) => {
          try {
            splide.destroy();
          } catch (e) {
          }
        });
        this.instances.clear();
        
        // アクティブな動画をクリア
        this.activeVideos.forEach(video => {
          this.pauseVideo(video);
        });
        this.activeVideos.clear();
        
        // 全スライダーの初期化クラスを削除
        document.querySelectorAll('.c-product-item-slider').forEach(slider => {
          slider.classList.remove('is-initialized', 'splide--slide', 'splide--ltr', 'splide--draggable', 'is-active');
        });
        
        // 新しいスライダーを初期化
        const newSliders = document.querySelectorAll('.c-product-item-slider');
        newSliders.forEach(slider => this.initializeSingleSlider(slider));
        
        // 新しい動画要素を監視対象に追加
        this.observeAllVideos();
        
        this.processingTimeout = null;
      }, 300);
    },

    // DOM安定化待ち処理
    waitForDOMStable: function() {
      return new Promise((resolve) => {
        // 画像の読み込み状況を確認
        const images = document.querySelectorAll('.c-product-item img, .c-product-item video');
        let loadedImages = 0;
        const totalImages = images.length;

        if (totalImages === 0) {
          // 画像がない場合は少し待ってから解決
          setTimeout(resolve, 100);
          return;
        }

        const checkComplete = () => {
          loadedImages++;
          if (loadedImages >= totalImages) {
            // 全画像読み込み完了後、さらに少し待つ
            setTimeout(resolve, 50);
          }
        };

        images.forEach(img => {
          if (img.tagName === 'VIDEO' || img.complete) {
            checkComplete();
          } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true }); // エラー時も進める
            
            setTimeout(checkComplete, 3000);
          }
        });
      });
    },

    // 一般的なAjax更新時の処理（汎用）
    handleGenericAjaxUpdate: function(container = document) {
      setTimeout(() => {
        const newSliders = container.querySelectorAll('.c-product-item-slider:not(.is-initialized)');
        newSliders.forEach(slider => this.initializeSingleSlider(slider));
        
        // 新しい動画要素を監視対象に追加
        const newVideos = container.querySelectorAll('[data-video-element]');
        if (this.videoObserver && newVideos.length > 0) {
          newVideos.forEach(video => {
            this.videoObserver.observe(video);
          });
        }
      }, 100);
    },

    // 削除されたスライダーのインスタンスをクリーンアップ
    cleanupRemovedSliders: function() {
      const existingSliderIds = new Set();
      
      // 現在DOMに存在するスライダーのIDを収集
      document.querySelectorAll('.c-product-item-slider').forEach(slider => {
        const sliderId = slider.dataset.sliderId;
        if (sliderId) {
          existingSliderIds.add(sliderId);
        }
      });

      // 存在しないスライダーのインスタンスを削除
      const instancesToDelete = [];
      this.instances.forEach((splide, sliderId) => {
        if (!existingSliderIds.has(sliderId)) {
          instancesToDelete.push(sliderId);
        }
      });

      // 削除処理
      instancesToDelete.forEach(sliderId => {
        try {
          const splideInstance = this.instances.get(sliderId);
          if (splideInstance) {
            splideInstance.destroy();
          }
        } catch (e) {
        }
        this.instances.delete(sliderId);
      });

      // Ajax更新時は商品一覧エリアのスライダーインスタンスを全削除
      const isCollectionAjax = document.querySelector('.product-facet');
      if (isCollectionAjax) {
        // 商品一覧エリアのスライダーIDパターンをチェック
        const collectionSliderIds = [];
        this.instances.forEach((splide, sliderId) => {
          // 商品IDパターン（数字-pc または 数字-sp）をチェック
          if (/^\d+-(?:pc|sp)$/.test(sliderId)) {
            collectionSliderIds.push(sliderId);
          }
        });

        // 商品一覧のスライダーインスタンスを全て削除
        collectionSliderIds.forEach(sliderId => {
          try {
            const splideInstance = this.instances.get(sliderId);
            if (splideInstance) {
              splideInstance.destroy();
            }
          } catch (e) {
          }
          this.instances.delete(sliderId);
        });
      }
    },

    // 特定のコンテナ内のスライダーを削除
    cleanupSlidersInContainer: function(container) {
      const slidersInContainer = container.querySelectorAll('.c-product-item-slider');
      
      slidersInContainer.forEach(slider => {
        const sliderId = slider.dataset.sliderId;
        if (sliderId && this.instances.has(sliderId)) {
          try {
            this.instances.get(sliderId).destroy();
            this.instances.delete(sliderId);
          } catch (e) {
          }
        }
      });

      // コンテナ内の動画も停止
      const videosInContainer = container.querySelectorAll('[data-video-element]');
      videosInContainer.forEach(video => {
        this.pauseVideo(video);
        this.activeVideos.delete(video);
      });
    },

    // スライダーインスタンスの取得（スライダーIDまたは商品IDから）
    getSliderInstance: function(identifier) {
      // 直接スライダーIDで検索
      if (this.instances.has(identifier)) {
        return this.instances.get(identifier);
      }
      
      // 商品IDから検索
      for (const [sliderId, splideInstance] of this.instances) {
        if (sliderId.includes(identifier)) {
          return splideInstance;
        }
      }
      
      return null;
    },

    // カラーチップのイベントリスナー設定
    initializeColorSwatches: function() {
      // 既存のリスナーを削除
      if (this.colorSwatchHandler) {
        document.removeEventListener('click', this.colorSwatchHandler);
      }

      this.colorSwatchHandler = (e) => {
        const swatch = e.target.closest('.color-swatch__radio');
        if (!swatch) return;

        const variantId = swatch.dataset.variantId;
        const variantFeaturedMedia = swatch.dataset.variantFeaturedMedia;
        const productCard = swatch.closest('.c-product-item');

        if (variantId && productCard) {
          try {
            // 商品カード内のリンクを更新
            const links = productCard.querySelectorAll('a');
            links.forEach((link) => {
              const currentUrl = new URL(link.href);
              currentUrl.searchParams.set('variant', variantId);
              link.href = currentUrl.toString();
            });

            // スライダーの画像切り替え処理
            if (variantFeaturedMedia) {
              this.slideToVariantImage(productCard, variantFeaturedMedia);
            }

            // 同じ商品の他のカラーチップとの同期処理
            this.syncColorSwatches(swatch);

          } catch (error) {
          }
        }
      };

      document.addEventListener('click', this.colorSwatchHandler);
    },

    // 同じ商品のPC版・SP版カラーチップの同期処理
    syncColorSwatches: function(clickedSwatch) {
      const clickedValue = clickedSwatch.value;
      const clickedVariantId = clickedSwatch.dataset.variantId;
      const clickedMedia = clickedSwatch.dataset.variantFeaturedMedia;

      // 同じ商品の他のカラーチップを探すためのベース名を取得
      const baseName = clickedSwatch.name.replace(/-pc$|-sp$/, '');
      const productId = baseName.split('-').pop();

      // 同じ商品IDを含むすべてのカラーチップを取得
      const allSwatchesForProduct = document.querySelectorAll(`input[name*="${productId}"]`);

      // 同じ商品のすべてのカラーチップのチェックを外す
      allSwatchesForProduct.forEach((swatch) => {
        swatch.checked = false;
      });

      // 同じ値のカラーチップをすべてチェック状態にする
      allSwatchesForProduct.forEach((swatch) => {
        if (swatch.value === clickedValue) {
          swatch.checked = true;
          
          // 他の商品カードのリンクも更新
          const otherProductCard = swatch.closest('.c-product-item');
          if (otherProductCard) {
            const otherLinks = otherProductCard.querySelectorAll('a');
            otherLinks.forEach((link) => {
              const currentUrl = new URL(link.href);
              currentUrl.searchParams.set('variant', clickedVariantId);
              link.href = currentUrl.toString();
            });
            
            // 他の商品カードのスライダーも対応する画像に切り替え
            if (clickedMedia) {
              this.slideToVariantImage(otherProductCard, clickedMedia);
            }
          }
        }
      });
    },

    // 指定されたバリアントの画像にスライドする
    slideToVariantImage: function(productCard, variantFeaturedMediaId) {
      try {
        // 商品カード内のスライダーを探す
        const slider = productCard.querySelector('.c-product-item-slider');
        
        if (!slider) {
          return;
        }

        const sliderId = slider.dataset.sliderId;
        const splideInstance = this.getSliderInstance(sliderId);
        
        if (!splideInstance) {
          return;
        }

        // 対象のメディアIDを持つスライドを検索
        const slides = slider.querySelectorAll('.splide__slide[data-media-id]');
        let targetSlideIndex = -1;

        slides.forEach((slide, index) => {
          const slideMediaId = slide.getAttribute('data-media-id');
          
          if (slideMediaId === variantFeaturedMediaId) {
            targetSlideIndex = index;
          }
        });

        // 対象のスライドが見つかった場合、そのスライドに移動
        if (targetSlideIndex !== -1) {
          splideInstance.go(targetSlideIndex);
        }
      } catch (error) {
      }
    },

    // 特定セクションのDOM変更監視を開始
    observeSection: function(sectionSelector, sectionId = null) {
      const section = document.querySelector(sectionSelector);
      if (!section) return;

      const observerId = sectionId || sectionSelector;
      
      // 既存の監視があれば停止
      if (this.observerInstances.has(observerId)) {
        this.observerInstances.get(observerId).disconnect();
      }

      const observer = new MutationObserver((mutations) => {
        let hasRelevantChanges = false;
        let addedNodes = [];

        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // 商品カードまたは商品リストの変更を監視
                const hasProductContent = node.querySelector && (
                  node.querySelector('.c-product-item') ||
                  node.querySelector('.c-product-item-slider')
                );
                
                if (hasProductContent || 
                    node.classList?.contains('c-product-item') ||
                    node.classList?.contains('c-product-item-slider')) {
                  hasRelevantChanges = true;
                  addedNodes.push(node);
                }
              }
            });
          }
        });

        if (hasRelevantChanges) {
          this.initializeNewSliders(addedNodes);
        }
      });

      observer.observe(section, {
        childList: true,
        subtree: true
      });

      this.observerInstances.set(observerId, observer);
    },

    // システム全体の初期化
    initialize: function() {
      // Splideライブラリの確認
      if (typeof Splide === 'undefined') {
        setTimeout(() => this.initialize(), 1000);
        return;
      }

      this.initializeVideoSystem();
      this.initializeAllSliders();
      this.initializeColorSwatches();
      
      // 各セクションの監視を開始
      this.startSectionObservers();
    },

    // 各セクションのDOM変更監視を開始
    startSectionObservers: function() {
      // 商品一覧ページの監視（Ajax対応）
      this.observeSection('.product-facet', 'collection-page');
      
      // おすすめ商品セクションの監視
      this.observeSection('product-recommendations', 'product-recommendations');
      
      // その他の商品カードを含む可能性があるセクション
      const otherSections = document.querySelectorAll('[class*="product"], [class*="recommendation"]');
      otherSections.forEach((section, index) => {
        if (!section.classList.contains('product-facet') && 
            section.tagName.toLowerCase() !== 'product-recommendations') {
          this.observeSection(`[class="${section.className}"]`, `other-section-${index}`);
        }
      });
    },

    // 外部から特定コンテナの初期化を強制実行するためのAPI
    forceInitialize: function(container = document) {
      setTimeout(() => {
        const sliders = container.querySelectorAll('.c-product-item-slider');
        sliders.forEach(slider => {
          // 強制的に未初期化状態にする
          const sliderId = slider.dataset.sliderId;
          if (sliderId && this.instances.has(sliderId)) {
            try {
              this.instances.get(sliderId).destroy();
              this.instances.delete(sliderId);
            } catch (e) {
            }
          }
          slider.classList.remove('is-initialized', 'splide--slide', 'splide--ltr', 'splide--draggable', 'is-active');
          this.initializeSingleSlider(slider);
        });

        // 動画の再監視
        const videos = container.querySelectorAll('[data-video-element]');
        if (this.videoObserver && videos.length > 0) {
          videos.forEach(video => {
            this.videoObserver.observe(video);
          });
        }
      }, 50);
    },

    // 動画システムのクリーンアップ
    cleanup: function() {
      // 全ての動画を停止
      this.activeVideos.forEach(video => {
        this.pauseVideo(video);
      });
      this.activeVideos.clear();

      // 動画オブザーバーを停止
      if (this.videoObserver) {
        this.videoObserver.disconnect();
        this.videoObserver = null;
      }

      // その他のオブザーバーも停止
      this.observerInstances.forEach(observer => {
        observer.disconnect();
      });
      this.observerInstances.clear();

      // スライダーインスタンスをクリーンアップ
      this.instances.forEach(splide => {
        try {
          splide.destroy();
        } catch (e) {
        }
      });
      this.instances.clear();
    }
  };

  // 商品一覧ページでのAjax通信監視
  function initializeCollectionAjaxMonitoring() {
    // 商品一覧ページでのみ実行
    if (!document.querySelector('.product-facet')) return;

    const originalFetch = window.fetch;
    window.fetch = function(url, ...args) {
      const urlString = typeof url === 'string' ? url : url.toString();

      return originalFetch.apply(this, [url, ...args])
        .then(response => {
          if (urlString.includes('/collections/') && urlString.includes('section_id=')) {
            window.ProductSliderManager.handleCollectionAjaxUpdate();
          }
          return response;
        })
        .catch(error => {
          throw error;
        });
    };
  }

  // ページ終了時のクリーンアップ
  function setupCleanup() {
    // ページ非表示時に動画を停止（バックグラウンドタブ等）
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && window.ProductSliderManager) {
        window.ProductSliderManager.activeVideos.forEach(video => {
          window.ProductSliderManager.pauseVideo(video);
        });
      }
    });

    // ページアンロード時は動画のみ停止（スライダー構造は保持）
    window.addEventListener('pagehide', () => {
      if (window.ProductSliderManager) {
        // 動画のみ停止
        window.ProductSliderManager.activeVideos.forEach(video => {
          if (video && video.pause) {
            video.pause();
          }
        });
        window.ProductSliderManager.activeVideos.clear();
        
        // 動画オブザーバーのみ停止
        if (window.ProductSliderManager.videoObserver) {
          window.ProductSliderManager.videoObserver.disconnect();
        }
      }
    });
  }

  // システム開始
  function startUniversalSliderSystem() {
    window.ProductSliderManager.initialize();
    initializeCollectionAjaxMonitoring();
    setupCleanup();
  }

  // DOM準備完了後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(startUniversalSliderSystem, 100);
    });
  } else {
    setTimeout(startUniversalSliderSystem, 100);
  }

  // 外部からの強制初期化用グローバル関数
  window.initProductSliders = function(container = document) {
    if (window.ProductSliderManager) {
      window.ProductSliderManager.forceInitialize(container);
    }
  };
}